import React, { useEffect, useState } from "react";
import PatientService from "../../../../../Services/PatientService";
import ConsultationService from "../../../../../Services/ConsultationService";
import jsPDF from "jspdf";
import { SpaceContextProvider } from "antd/es/space/context";
import logo from "../../../../../Assets/Images/hospital logo.webp";
import DoctorService from "../../../../../Services/DoctorService";
import PrescriptionHeader from "./PrescriptionHeader";
import PrescriptionFooter from "./PrescriptionFooter";

const PrescriptionDetails = ({
  prescription,
  selectedPatient,
  editedPatientDetails,
}) => {
  const [doctorData, setDoctorData] = useState();
  const [hospitalAccountData, setHospitalAccountData] = useState(null);
  const [selectedPatientDetails, setSelectedPatientDetails] = useState([]);
  const [clinicDetails, setClinicDetails] = useState(null);
  const [age, setAge] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let payload = {
      patientId: selectedPatient?.patientId,
    };
    PatientService.PatientListFilter(payload)
      .then((result) => {
        setSelectedPatientDetails(result.data[0]);
        const dobYear = result?.data[0]?.dob?.slice(6);
        const currYear = new Date().getFullYear();
        if (dobYear) {
          const patientAge = currYear - Number(dobYear);
          setAge(patientAge);
        }
      })
      .catch((error) => {
        console.error("Error fetching patient list:", error);
      });
  }, [selectedPatient?.patientId]);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true); // Start loader

      try {
        const response = await getDoctorName(prescription?.userId);

        setDoctorData(response?.data[0]);
        fetchHospitalData(response?.data[0]?.account_Id);
        fetchClinicData(response?.data[0]?.clinic_Id);
      } catch (e) {
        console.error(e);
      } finally {
        setIsLoading(false); // Stop loader
      }
    };

    fetchData();
  }, [prescription?.userId]);

  const getDoctorName = async (id) => {
    try {
      const response = await DoctorService.getDoctorData(id);
      return response;
    } catch (e) {
      console.error(e);
    }
  };

  const fetchHospitalData = async (id) => {
    const response = await DoctorService.getHospitalAccountData(id);
    setHospitalAccountData(response.data[0]);
  };

  const fetchClinicData = async (AccId) => {
    const response = await ConsultationService.getClinicData(AccId);
    setClinicDetails(response.data[0]);
  };

  const calculateAge = (dob) => {
    if (!dob || typeof dob !== "string" || isNaN(new Date(dob).getTime())) {
      return null;
    }
    const dobParts = dob.split("/");
    const dobYear = dobParts[2];
    if (dobYear && !isNaN(dobYear)) {
      const currYear = new Date().getFullYear();
      const patientAge = currYear - Number(dobYear);
      return patientAge;
    }
    return null;
  };

  return (
    <section>
      <div
        id="prescription"
        className="w-full mb-4 border rounded overflow-x-auto cursor-pointer"
      >
        {isLoading ? (
          <div className="w-full flex h-screen justify-center items-center">
            <div className="spinner"></div>
          </div>
        ) : (
          <>
            <div className="md:p-3 p-4">
              <div className="md:flex justify-between"></div>
              <PrescriptionHeader
                clinicDetails={clinicDetails}
                doctorData={doctorData}
                hospitalAccountData={hospitalAccountData}
              />
              <div className="mt-3">
                <div className="md:flex justify-end gap-1">
                  <div className="text-sm font-bold">Date:</div>
                  <h6 className="text-sm text-gray-700 font-semibold">
                    {prescription?.consultationDate
                      ? `${prescription?.consultationDate
                          .slice(0, 11)
                          .split("-")[2]
                          .trim()}-${
                          prescription?.consultationDate
                            .slice(0, 11)
                            .split("-")[1]
                        }-${
                          prescription?.consultationDate
                            .slice(0, 11)
                            .split("-")[0]
                        }`
                      : ""}
                  </h6>
                </div>
              </div>
              <div className="md:flex gap-5  my-2">
                <div className="text-sm font-bold flex gap-1">
                  Name:
                  <span className="text-sm text-gray-500 font-semibold">
                    {selectedPatient?.patientName
                      ? selectedPatient?.patientName
                      : selectedPatient?.firstName +
                        " " +
                        selectedPatient?.lastName}
                  </span>
                </div>
                <div className="text-sm font-bold md:flex gap-1">
                  Age/Gender:
                  <span className="text-sm text-gray-500 font-semibold">
                    {selectedPatientDetails?.ageDob
                      ? calculateAge(selectedPatientDetails?.ageDob)
                      : null || editedPatientDetails?.age || "NA"}
                    /
                    {selectedPatientDetails?.gender ||
                      editedPatientDetails?.gender ||
                      "NA"}
                  </span>
                </div>
                <div className="text-sm font-bold md:flex gap-1">
                  Phone Number:
                  <span className="text-sm text-gray-500 font-semibold">
                    {selectedPatientDetails?.mobile}
                  </span>
                </div>

                <div className="text-sm font-bold flex gap-1">
                  Visit Type:
                  <span className=" text-sm text-gray-500 font-semibold">
                    {prescription?.consultationType}
                  </span>
                </div>
              </div>
              <hr />
              <div className="md:flex gap-3 my-3 md:flex-wrap justify-stretch">
                <div
                  className={`gap-1 md:w-[20%] ${
                    prescription?.patientVitals?.find(
                      (vital) => vital.vitalCode === "BPS"
                    )?.value
                      ? "flex"
                      : "hidden"
                  }`}
                >
                  <label className="font-medium text-sm">BP:</label>
                  <span className="text-gray-500 text-sm">
                    {`${
                      prescription?.patientVitals.find(
                        (vital) => vital.vitalCode === "BPS"
                      )?.value
                    }/${
                      prescription?.patientVitals.find(
                        (vital) => vital.vitalCode === "BPD"
                      )?.value
                    }`}{" "}
                    mmHg
                  </span>
                </div>
                <div
                  className={`gap-1 md:w-[20%] ${
                    prescription?.patientVitals.find(
                      (vital) => vital.vitalCode === "SPO2"
                    )?.value
                      ? "flex"
                      : "hidden"
                  }`}
                >
                  <label className="font-medium text-sm">SPO2:</label>
                  <span className="text-gray-500 text-sm">
                    {
                      prescription?.patientVitals.find(
                        (vital) => vital.vitalCode === "SPO2"
                      )?.value
                    }{" "}
                    %
                  </span>
                </div>
                <div
                  className={`gap-1 md:w-[20%] ${
                    prescription?.patientVitals.find(
                      (vital) => vital.vitalCode === "HR"
                    )?.value
                      ? "flex"
                      : "hidden"
                  }`}
                >
                  <label className="font-medium text-sm">HR:</label>
                  <span className="text-gray-500 text-sm">
                    {
                      prescription?.patientVitals.find(
                        (vital) => vital.vitalCode === "HR"
                      )?.value
                    }{" "}
                    Beats/min
                  </span>
                </div>
                <div
                  className={`gap-1 md:w-[30%] ${
                    prescription?.patientVitals.find(
                      (vital) => vital.vitalCode === "RR"
                    )?.value
                      ? "flex"
                      : "hidden"
                  }`}
                >
                  <label className="font-medium text-sm">RR:</label>
                  <span className="text-gray-500 text-sm">
                    {
                      prescription?.patientVitals.find(
                        (vital) => vital.vitalCode === "RR"
                      )?.value
                    }{" "}
                    Breaths/min
                  </span>
                </div>
                <div
                  className={`gap-1 md:w-[20%] ${
                    prescription?.patientVitals.find(
                      (vital) => vital.vitalCode === "TP"
                    )?.value
                      ? "flex"
                      : "hidden"
                  }`}
                >
                  <label className="font-medium text-sm">Temp:</label>
                  <span className="text-gray-500 text-sm">
                    {
                      prescription?.patientVitals.find(
                        (vital) => vital.vitalCode === "TP"
                      )?.value
                    }{" "}
                    °F
                  </span>
                </div>
                <div
                  className={`gap-1 md:w-[20%] ${
                    prescription?.patientVitals.find(
                      (vital) => vital.vitalCode === "HI"
                    )?.value
                      ? "flex"
                      : "hidden"
                  }`}
                >
                  <label className="font-medium text-sm">Ht:</label>
                  <span className="text-gray-500 text-sm">
                    {
                      prescription?.patientVitals.find(
                        (vital) => vital.vitalCode === "HI"
                      )?.value
                    }{" "}
                    cm
                  </span>
                </div>
                <div
                  className={`gap-1 md:w-[20%] ${
                    prescription?.patientVitals.find(
                      (vital) => vital.vitalCode === "WE"
                    )?.value
                      ? "flex"
                      : "hidden"
                  }`}
                >
                  <label className="font-medium text-sm">Wt:</label>
                  <span className="text-gray-500 text-sm">
                    {
                      prescription?.patientVitals.find(
                        (vital) => vital.vitalCode === "WE"
                      )?.value
                    }{" "}
                    kg
                  </span>
                </div>
                <div
                  className={`gap-1 md:w-[20%] ${
                    prescription?.patientVitals.find(
                      (vital) => vital.vitalCode === "BMI"
                    )?.value
                      ? "flex"
                      : "hidden"
                  }`}
                >
                  <label className="font-medium text-sm">BMI:</label>
                  <span className="text-gray-500 text-sm">
                    {
                      prescription?.patientVitals.find(
                        (vital) => vital.vitalCode === "BMI"
                      )?.value
                    }{" "}
                    Kg/m<sup>2</sup>
                  </span>
                </div>
              </div>

              <hr className="hr-line mt-3" />

              {prescription?.consultationReason && (
                <div className="md:grid grid-cols-1 my-2">
                  <p>
                    <b className=" font-bold">Chief Complaint : </b>
                    <span className="text-gray-500 font-semibold">{`${
                      prescription?.consultationReason
                        ? prescription?.consultationReason
                            ?.charAt(0)
                            .toUpperCase()
                        : ""
                    }${
                      prescription?.consultationReason
                        ? prescription?.consultationReason?.slice(1)
                        : ""
                    }`}</span>
                  </p>
                </div>
              )}
              {prescription?.symptoms && (
                <div className="mb-5">
                  <p className="">
                    <span className="font-bold">Symptoms : </span>
                    <span className="text-gray-500 font-semibold">
                      {prescription?.symptoms}
                    </span>
                  </p>
                </div>
              )}
              {prescription?.patientDiagnosisDetails?.filter(
                (diagnosis) =>
                  diagnosis.diagnosisType === "Primary" &&
                  diagnosis?.status === 1
              )?.length !== 0 && (
                <div className="md:grid grid-cols-1 my-2">
                  <p className="">
                    <b className="font-bold">Primary Diagnosis :</b>
                  </p>

                  <>
                    <ol className="list-decimal ml-5">
                      {prescription?.patientDiagnosisDetails
                        ?.filter(
                          (diagnosis) =>
                            diagnosis?.diagnosisType === "Primary" &&
                            diagnosis?.status === 1
                        )
                        ?.map((primaryDiagnosis) => (
                          <li>
                            <span>
                              {primaryDiagnosis?.diagnosisDescription}
                            </span>
                            <span className="font-bold">
                              ({primaryDiagnosis?.diagnosisCode})
                            </span>
                          </li>
                        ))}
                    </ol>
                  </>
                </div>
              )}

              {prescription?.patientDiagnosisDetails?.filter(
                (diagnosis) =>
                  diagnosis?.diagnosisType === "Secondary" &&
                  diagnosis?.status === 1
              )?.length !== 0 && (
                <div className="md:grid grid-cols-1 my-2">
                  <p className="">
                    <b className="font-bold">Secondary Diagnosis :</b>
                  </p>

                  <>
                    <ol className="list-decimal ml-5">
                      {prescription?.patientDiagnosisDetails
                        ?.filter(
                          (diagnosis) =>
                            diagnosis?.diagnosisType === "Secondary" &&
                            diagnosis?.status === 1
                        )
                        ?.map((secondaryDiagnosis) => (
                          <li>
                            <span>
                              {secondaryDiagnosis?.diagnosisDescription}
                            </span>
                            <span className="font-bold">
                              ({secondaryDiagnosis?.diagnosisCode})
                            </span>
                          </li>
                        ))}
                    </ol>
                  </>
                </div>
              )}

              <div className="mb-2 overflow-scroll scrollWidth">
                {prescription?.specialityDetails?.length !== 0 && (
                  <div className="mt-2  mb-5">
                    <p className="mb-2">
                      <b className="font-bold">Speciality Notes :</b>
                    </p>

                    <div className="md:w-[60%] w-full">
                      <div>
                        {prescription?.specialityDetails &&
                          prescription?.specialityDetails.map(
                            (template, idx) => (
                              <div
                                key={idx}
                                className={`${
                                  template?.componentDetailsList?.length !== 0
                                    ? "block"
                                    : "hidden"
                                }`}
                              >
                                <p>
                                  <b className="font-semibold border p-1.5 rounded-lg bg-brand-lightBg">
                                    {template.templateName}
                                  </b>
                                </p>
                                <div className="w-full flex items-center gap-2 flex-wrap">
                                  {template?.componentDetailsList.map(
                                    (formFields, index) => (
                                      <div
                                        key={index}
                                        className="text-sm flex items-center gap-1"
                                      >
                                        <p className="font-medium w-max my-1 py-1">
                                          {formFields.componentLabel}
                                        </p>
                                        {" : "}
                                        <p className="text-gray-700 w-max my-1 py-1">
                                          {formFields.componentValue}
                                        </p>
                                        {template?.componentDetailsList
                                          ?.length -
                                          1 !==
                                          index && (
                                          <span className="font-medium">|</span>
                                        )}
                                      </div>
                                    )
                                  )}
                                </div>
                              </div>
                            )
                          )}
                      </div>
                    </div>
                  </div>
                )}

                {prescription?.drugPrescription?.length !== 0 && (
                  <div>
                    <p className="mb-2">
                      <b className="font-bold">Medicines :</b>
                    </p>
                    <table className="table-auto w-full mb-5 overflow-y-scroll">
                      <thead className="border-b-2 border-t-2 border-gray-400">
                        <tr>
                          <th className="px-3 py-1 text-left">Medicines</th>
                          <th className="px-3 py-1 text-left">Dosage</th>
                          <th className="px-3 py-1 text-left">Duration</th>
                        </tr>
                      </thead>
                      <tbody>
                        {prescription?.drugPrescription &&
                          prescription?.drugPrescription?.map(
                            (medicine, idx) => {
                              if (medicine?.status !== 0) {
                                return (
                                  <tr className="border-b-2 text-gray-500">
                                    <td className="text-gray-700 font-semibold px-3 py-1">
                                      {medicine?.drugName}
                                    </td>
                                    <td className="text-gray-700 font-semibold px-3 py-1 flex flex-col">
                                      {medicine?.dosage}
                                      {medicine?.frequency
                                        ? `-(${medicine?.frequency})`
                                        : ""}
                                      <br />
                                      {medicine?.afterBeforeFood === "AF"
                                        ? "After Food"
                                        : medicine?.afterBeforeFood === "BF"
                                        ? "Before Food"
                                        : ""}
                                    </td>
                                    <td className="text-gray-700 font-semibold px-3 py-1">
                                      {medicine?.duration
                                        ? medicine?.duration + " days"
                                        : ""}
                                      <br />
                                      {medicine?.instruction?.length > 20
                                        ? `(${medicine?.instruction?.slice(
                                            0,
                                            20
                                          )}...)`
                                        : medicine?.instruction}
                                    </td>
                                  </tr>
                                );
                              }
                            }
                          )}
                      </tbody>
                    </table>
                  </div>
                )}

                {prescription?.labPrescription?.length !== 0 && (
                  <div className="mt-2  mb-5">
                    <p className="mb-2">
                      <b className="font-bold">Lab Test :</b>
                    </p>

                    <div className="md:w-[60%]">
                      <div className="text-gray-700 font-semibold">
                        {prescription?.labPrescription &&
                          prescription?.labPrescription
                            ?.filter((item) => item.status !== 0)
                            .map((lab, idx) => {
                              if (lab?.status !== 0) {
                                return (
                                  <div
                                    key={idx}
                                    className="text-sm border text-gray-700 px-3 py-1"
                                  >
                                    {lab?.labTestName}
                                  </div>
                                );
                              }
                            })}
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="my-2">
                <div className="md:w-6/6  my-2">
                  {prescription?.recommendation && (
                    <div className="mb-5">
                      <p>
                        <b className="mr-3">Recommendation :</b>
                        <span className="text-gray-700 font-semibold">
                          {prescription?.recommendation}
                        </span>
                      </p>
                    </div>
                  )}

                  {prescription?.followupVisitDate && (
                    <div>
                      <p className=" my-2">
                        <b className="mr-3">Scheduled Follow-up :</b>
                        <span className="text-gray-700 font-semibold">
                          {prescription?.followupVisitDate
                            ? `${
                                prescription?.followupVisitDate
                                  ?.slice(0, 10)
                                  .split("/")[1]
                              }-${
                                prescription?.followupVisitDate
                                  ?.slice(0, 10)
                                  .split("/")[0]
                              }-${
                                prescription?.followupVisitDate
                                  ?.slice(0, 10)
                                  .split("/")[2]
                              }`
                            : ""}
                        </span>
                      </p>
                    </div>
                  )}
                </div>
              </div>

              <div className="md:flex justify-between px-4">
                <div className="md:flex  items-center">
                  {doctorData?.doctorStampName ? (
                    <img
                      id="imag"
                      src={`${process.env.REACT_APP_IMAGE_URL}${doctorData?.doctorStampName}`}
                      alt="Stamp"
                      className="md:h-32 h-28 md:w-36 w-30 rounded-full"
                    />
                  ) : (
                    <div>&nbsp;</div>
                  )}
                </div>

                <div className="">
                  {doctorData?.doctorSignatureName ? (
                    <img
                      src={`${process.env.REACT_APP_IMAGE_URL}${doctorData?.doctorSignatureName}`}
                      alt="Signature"
                      className="md:w-28 w-20 md:h-28 h-20  rounded-full"
                    />
                  ) : (
                    <div>&nbsp;</div>
                  )}
                  <p className="font-bold text-sm mb-1">
                    {` Dr.${doctorData?.firstName} ${doctorData?.lastName}`}
                  </p>
                  <p className="font-semibold text-gray-700 text-sm mb-1">
                    {doctorData?.qualification}
                    <br />
                    {doctorData?.speciality}
                  </p>
                  <p className="font-semibold text-gray-700 text-sm mb-1">
                    Regn No. {doctorData?.registrationNumber}
                  </p>
                </div>
              </div>
            </div>
            <div className=" ">
              <PrescriptionFooter
                clinicDetails={clinicDetails}
                doctorData={doctorData}
              />
            </div>
            <div className="grid grid-cols-1 ">
              <div className="px-1 py-1">
                <p className="text-gray-700 text-sm "></p>
              </div>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default PrescriptionDetails;
